export default function NoticeIcon(props: any) {
  const { on = false, ...rest } = props;
  return on ? (
    <svg
      {...rest}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <g fill="none" fillRule="evenodd">
        <g>
          <g transform="translate(-1265 -634) translate(1265 634)">
            <circle cx="8" cy="8" r="8" fill="#000" />
            <path fill="#FFF" d="M7 7H9V12H7zM7 4H9V6H7z" />
          </g>
        </g>
      </g>
    </svg>
  ) : (
    <svg
      {...rest}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <g fill="none" fillRule="evenodd">
        <g>
          <g transform="translate(-1257 -553) translate(1257 553)">
            <circle cx="8" cy="8" r="7.5" stroke="#222" />
            <path fill="#222" d="M7 7H9V12H7zM7 4H9V6H7z" />
          </g>
        </g>
      </g>
    </svg>
  );
}
